import { useQuery } from 'react-query';

import { ISelectModel } from 'common/models';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getCountriesFromRoot } from 'services/api/apiCalls/rentals';

const getCountries = (): Promise<ISelectModel<number>[]> =>
  getCountriesFromRoot().then(response => response.data);

export const useCountriesQuery = (enabled?: boolean) =>
  useQuery(QUERY_KEYS.RENTALS_COUNTRIES, getCountries, { enabled });
